module.exports = __webpack_public_path__ + "static/img/carousel-2.feb4d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/home/carousel-2.png
// module id = kyLo
// module chunks = 15